<template>
  <div class="companyAdd">
    <Breadcumb title="Ajouter une filiale" :breadcumb-data="breadcumbData"></Breadcumb>
    <b-card class="cardcontainer">
      <b-form @submit="companyAdd">
        <b-form-group label="Nom" label-align-md="right" label-class="pr-md-2" :label-cols-md="2">
          <b-input type="text" placeholder="Nom" v-model="name" :state="errors['name'] ? 'invalid': ''"/>
          <div v-if="errors['name']" role="alert" aria-live="polite" aria-atomic="true"
               class="alert alert-dismissible alert-danger">
            {{ errors['name'][0] }}
          </div>
        </b-form-group>
        <b-form-group label="Branche" label-align-md="right" label-class="pr-md-2" :label-cols-md="2">
          <b-input type="text" placeholder="Branche" v-model="branch" :state="errors['country'] ? 'invalid': ''"/>
          <div v-if="errors['branch']" role="alert" aria-live="polite" aria-atomic="true"
               class="alert alert-dismissible alert-danger">
            {{ errors['branch'][0] }}
          </div>
        </b-form-group>
        <b-form-group label="Code" label-align-md="right" label-class="pr-md-2" :label-cols-md="2">
          <b-input type="text" placeholder="Code" v-model="code" :state="errors['country'] ? 'invalid': ''"/>
          <div v-if="errors['code']" role="alert" aria-live="polite" aria-atomic="true"
               class="alert alert-dismissible alert-danger">
            {{ errors['code'][0] }}
          </div>
        </b-form-group>
        <b-form-group label="Pays" label-align-md="right" label-class="pr-md-2" :label-cols-md="2">
          <b-input type="text" placeholder="Pays" v-model="country" :state="errors['country'] ? 'invalid': ''"/>
          <div v-if="errors['country']" role="alert" aria-live="polite" aria-atomic="true"
               class="alert alert-dismissible alert-danger">
            {{ errors['country'][0] }}
          </div>
        </b-form-group>
        <b-form-group label="Affiliation" label-align-md="right" label-class="pr-md-2" :label-cols-md="2">
          <v-jstree
                  :data="treeData"
                  :class="{ 'tree-rtl': isRTL }"
                  show-checkbox
                  allow-batch
                  whole-row
                  @item-click="itemClick"/>
        </b-form-group>
        <b-form-group label="Langue" label-align-md="right" label-class="pr-md-2" :label-cols-md="2">
          <b-select plain v-model="language" :options="languageData"/>
          <div v-if="errors['language']" role="alert" aria-live="polite" aria-atomic="true"
               class="alert alert-dismissible alert-danger">
            {{ errors['language'][0] }}
          </div>
        </b-form-group>
        <b-form-row>
          <div class="col-md-10 ml-md-auto">
            <b-btn type="submit" variant="primary">Ajouter une filiale</b-btn>
          </div>
        </b-form-row>
      </b-form>
    </b-card>
  </div>
</template>
<style src="@/vendor/libs/vue-jstree/vue-jstree.scss" lang="scss"></style>
<script>
  import { GET_LANGUAGES_REQUEST } from '../_store/translation/actiontypes'
  import {
    ADD_COMPANY_REQUEST,
    GET_COMPANIES_REQUEST,
    GET_HIERARCHICAL_COMPANIES_REQUEST
  } from '../_store/company/actiontypes'

  import { mapState } from 'vuex'
  import Breadcumb from '../components/breadcumb'
  import VJstree from 'vue-jstree';

  function getChildrens(company) {
    return company.companies.map(children => {
      if (children.companies.length > 0){
        return {
          'show-checkbox': false,
          'text': children.name,
          'id': children.id,
          'selected': false,
          'children': getChildrens(children),
          'opened': false,
        }
      }
      else {
        return {
          'show-checkbox': false,
          'text': children.name,
          'id': children.id,
          'selected': false,
          'children': [],
          'opened': false,
        }
      }
    })
  }

  export default {
    name: 'companyAdd',
    components: { Breadcumb, VJstree},
    mounted() {
      this.$store.dispatch(GET_LANGUAGES_REQUEST)
        .then(response => {
          this.languageData = response.data.languages.map(language => {
            return {
              value: language.id,
              text: language.name
            }
          })
        })
      this.$store.dispatch(GET_HIERARCHICAL_COMPANIES_REQUEST)
        .then(response => {
          this.treeData = response.data.hierarchical_companies.map(company => {
            let childrens = [];
            if (company.companies.length > 0){
              childrens = getChildrens(company)
            }
            return {
              'show-checkbox': true,
              'text': company.name,
              'id': company.id,
              'children': childrens,
              'opened': false,
            }
          });
        });
    },
    computed: mapState({
      errors: state => state.company.errors,
      user: state => state.user.user
    }),
    data() {
      return ({
        breadcumbData: [
          { text: 'Accueil', href: '/dashboard/' },
          { text: 'Liste des filiales', href: '/company/' },
          { text: 'Création d\'une filiale', active: true }
        ],
        father: null,
        treeData: [],
        companiesData: [],
        companies: [],
        languageData: [],
        language: null,
        type: 'AFFI',
        companyType: [
          {value:'AFFI', text:'Filiale'},
          {value:'AREA', text:'Territoire'}
        ],
        name: '',
        country: '',
        branch: '',
        code: ''
      })
    },
    layout(context) {
      return 'layout'
    },
    methods: {
      itemClick (node) {
        this.father = node.data.id;
      },
      companyAdd: function(e) {
        e.preventDefault();
        console.log(this.treeData);
        this.$store.dispatch(ADD_COMPANY_REQUEST, {
          language: this.language,
          name: this.name,
          country: this.country,
          code: this.code,
          branch: this.branch,
          creator: this.user.userprofile.id,
          father: this.father
        })
          .then(() => {
            this.$router.push('/company/')
          })
          .catch((error) => {
            console.log('error is ==')
            console.log(error)
          })
      }
    }
  }
</script>
